// extracted by mini-css-extract-plugin
export default {"hero_section":"SigninPage_hero_section__OaLGm","form_section":"SigninPage_form_section__fDa5N","form":"SigninPage_form__O7J5M"};